/**
 * Re-initialize Alpine inside the FacetWP results grid after a refresh.
 *
 * When a facet changes, FacetWP replaces the .facetwp-template markup wholesale
 * ( front.js render(): $( '.facetwp-template' ).html( val ) ). Any Alpine
 * component in the new markup — e.g. the videoLightbox button on Video resource
 * cards — needs Alpine to scan the injected nodes. Alpine.initTree() is
 * idempotent on already-initialized roots, so re-running it over each template
 * on `facetwp-loaded` is safe.
 */

document.addEventListener( 'facetwp-loaded', () => {

	if ( ! window.Alpine ) {
		return;
	}

	document.querySelectorAll( '.facetwp-template' ).forEach( ( el ) => {
		window.Alpine.initTree( el );
	});
});
